// import { useState, useEffect } from "react";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const useUniversityApprovalStatus = () => {
//   const [isUniversityApproved, setIsUniversityApproved] = useState(false);

//   const fetchCurrentUniversityApprovalStatus = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}/marketplace/university/approval_status`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           "Content-Type": "application/json",
//           "x-api-key": process.env.REACT_APP_X_API_KEY
//         },
//       });
//       const data = await res.json();
//       // console.log(data?.approval_status)
//       setIsUniversityApproved(data?.approval_status);
//     } catch (err) {
//       console.error("Error fetching teacher:", err);
//     }
//   };

//   useEffect(() => {
//     fetchCurrentUniversityApprovalStatus();
//   }, []);

//   return { isUniversityApproved, fetchCurrentUniversityApprovalStatus };
// };

// export default useUniversityApprovalStatus;
// hooks/useUniversityApprovalStatus.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useUniversityApprovalStatus = (profileExists) => {
  const [isUniversityApproved, setIsUniversityApproved] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!profileExists) return; 

    const fetchApprovalStatus = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/university/approval_status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        console.log("The document status is:",data)
        if (data?.approval_status === false) {
          navigate("/marketplace/university/status");
          setIsUniversityApproved(false)
        }
        else{
           setIsUniversityApproved(true)
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace/university"); // redirect on error
      }
    };

    fetchApprovalStatus();
  }, [navigate, profileExists]);

  return isUniversityApproved ;
};

export default useUniversityApprovalStatus;
